import { Button, Input } from 'antd';
import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { setCookie } from '../helper/_cookieHelper.js';
import { loginUser } from '../services/apiservice';
import { notification } from 'antd';
import logo from '../assets/logo.svg'

const Login = () => {
    const [loginData, setLoginData] = useState({
        username: '', // Change 'name' to 'username'
        password: '',
    });
    const [loading, setLoading] = useState(false);
    let navigate = useNavigate();
    const location = useLocation();
    const from = location.state?.from?.pathname || '/dashboard';
    const [api] = notification.useNotification();

    const openNotificationWithIcon = (type, title = '', msg = '') => {
        api[type]({
            message: title,
            description: msg,
        });
    };

    const removeAndRedirectToLogin = () => {
        let keysToRemove = [
            'user',
            'user_type',
        ];
        for (let key of keysToRemove) {
            localStorage.removeItem(key);
        }
        navigate('/login', { replace: true });
        return;
    };

    const handleLoginClick = async () => {
        if (!loginData.username || !loginData.username.trim()) {
            openNotificationWithIcon(
                'error',
                'Username is required!',
                'Please enter a valid username!'
            );
            return;
        }
        if (!loginData.password || !loginData.password.trim()) {
            openNotificationWithIcon(
                'error',
                'Password is required!',
                'Please enter a valid password!'
            );
            return;
        }
        try {
            setLoading(true);
            const response = await loginUser(loginData);
            if (response.status === 200) {
                const data = response?.data || {};
                localStorage.setItem('user', data?.access_token);
                setCookie('token', `${data?.access_token}`, 1);
                localStorage.setItem('user_type', data?.user_type);
                if (data?.user_type === "global_supervisor") {
                    navigate('/analytics', { replace: true });
                }
                else{
                    removeAndRedirectToLogin();
                }
            }
        } catch (error) {
            openNotificationWithIcon(
                'error',
                '',
                'Something went wrong! Please try again.'
            );
        } finally {
            setLoading(false);
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setLoginData({ ...loginData, [name]: value });
    };

    return (
        <div className='outlet-screen bg-img min-h-dvh flex flex-col justify-center items-center px-4 pb-4'>
            {/* Header section */}
            <div className='head-section w-full z-10 flex justify-center items-center flex-row py-3 relative md:justify-center md:flex-col md:py-5'>
                    <img
                        src={logo}
                        alt='logo'
                        className='max-w-32 md:max-w-60'
                    />
            </div>

            {/* Login Form */}
            <div className='login-wrapper w-full max-w-md bg-white p-6 rounded-xl shadow-lg flex flex-col justify-start items-center'>
                <div className='login-title text-center'>
                    <h2 className='title text-l font-bold mb-2'>Welcome back</h2>
                </div>

                <div className='w-full mt-6'>
                    <Input
                        type='text'
                        name='username' // Corrected to 'username'
                        className='form-control rounded-xl p-3 mb-4 border-gray-300 w-full'
                        placeholder='Enter username'
                        value={loginData.username}
                        onChange={handleInputChange}
                        size='large'
                    />
                    <Input.Password
                        type='password'
                        name='password' // Corrected to 'password'
                        className='form-control rounded-xl p-3 mb-4 border-gray-300 w-full'
                        placeholder='Enter Password'
                        value={loginData.password}
                        onChange={handleInputChange}
                        size='large'
                    />
                    <Button
                        type='primary'
                        className='w-full rounded-full px-4 py-3'
                        onClick={handleLoginClick}
                        disabled={loading}
                        size='large'
                    >
                        {loading ? (
                            <i className='fa fa-circle-o-notch fa-spin'></i>
                        ) : (
                            'Login'
                        )}
                    </Button>
                </div>
            </div>

            {/* Footer */}
            <div className='copyright text-center mt-6 text-gray-400'>
                Copyright &copy; ViralOps {new Date().getFullYear()}
            </div>
        </div>
    );
};

export default Login;
